import { atom } from 'jotai'
export const currentUserState = atom({
  email: null,
  plan: null,
  translate_to_language: null,
  language: null,
})
